import { render, staticRenderFns } from "./ONotesTable.vue?vue&type=template&id=0e60d4a9&"
import script from "./ONotesTable.vue?vue&type=script&lang=js&"
export * from "./ONotesTable.vue?vue&type=script&lang=js&"
import style0 from "./ONotesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports